<template>
  <v-container fluid class="fill-height d-flex align-center justify-center pa-4">
    <v-card class="pa-6 text-center" max-width="500" width="100%" elevation="4">
      <v-icon size="48" color="primary" class="mb-3">
        mdi-file-pdf-box
      </v-icon>

      <h2 class="mb-2">Subir documento PDF</h2>
      <p class="text--secondary mb-4">
        Arrastra tu archivo aquí o toca para seleccionarlo
      </p>

      <!-- Drop Zone -->
      <div
        class="drop-zone"
        :class="{ 'drop-zone--active': isDragging }"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="handleDrop"
        @click="triggerFileInput"
      >
        <v-icon size="36" color="grey">
          mdi-cloud-upload
        </v-icon>

        <div class="mt-2">
          <span v-if="!fileName">Seleccionar archivo PDF</span>
          <strong v-else>{{ fileName }}</strong>
        </div>
      </div>

      <v-btn class="mt-4" color="primary" block :loading="loading" :disabled="!selectedFile" @click="uploadFile">
        Subir archivo
      </v-btn>

      <input ref="fileInput" type="file" accept="application/pdf" hidden @change="handleFileSelect" />
    </v-card>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    token: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedFile: null,
      fileName: null,
      isDragging: false,
      loading: false,
    };
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      this.validateFile(file);
    },

    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.validateFile(file);
    },

    validateFile(file) {
      if (!file) return;

      if (file.type !== "application/pdf") {
        this.$toast?.error?.("Solo se permiten archivos PDF");
        return;
      }

      this.selectedFile = file;
      this.fileName = file.name;
    },

    /**
     * Sube un archivo PDF usando token externo.
     * Valida tipo de archivo y maneja estados visuales.
     * @async
     * @returns {Promise<void>}
     */
    async uploadFile() {
      if (!this.selectedFile) return;

      // Validar que sea PDF
      const fileType = this.selectedFile.type;
      const isPdf = fileType === "application/pdf";

      if (!isPdf) {
        this.$toast?.error?.("Solo se permiten archivos PDF");
        return;
      }

      this.loading = true;

      try {
        const fileNameToSend = this.selectedFile.name;

        const formData = new FormData();
        formData.append("file", this.selectedFile);
        formData.append("token", this.token);
        formData.append("type", "file");
        formData.append("mediaType", "file");
        formData.append("message", fileNameToSend);

        // ⚠️ NO forzar Content-Type
        const response = await PbxHttpClient.post("/externo/upload_document_by_token", formData);

        this.$toast?.success?.("Archivo subido correctamente");

        // Limpiar estados
        this.selectedFile = null;
        this.fileName = null;
      } catch (error) {
        console.error("Error al subir PDF:", error);
        this.$toast?.error?.("No se pudo subir el archivo PDF");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 12px;
  padding: 32px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: #f5f9ff;
}
</style>
